var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 81.610764, 90.828133)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.026448, 0, 0, 1.093667, 89.030251, 132.890961)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.333,32.971C501.28,14.746,486.492,0,468.267,0H43.733C25.509,0,10.72,14.746,10.667,32.971v345.696 c0,17.621,14.123,37.333,33.067,37.333h169.6v74.667H160c-5.891,0-10.667,4.776-10.667,10.667S154.109,512,160,512h128 c0.181,0,0.32-0.096,0.501-0.096c0.341,0,0.651,0.096,0.992,0.096h167.68c24.377-0.029,44.131-19.783,44.16-44.16V182.827 c-0.023-2.718-0.298-5.428-0.821-8.096c0.537-1.288,0.816-2.669,0.821-4.064V32.971z M234.667,490.667V416h10.667v51.84 c0.036,8.067,2.303,15.967,6.549,22.827H234.667z M245.333,182.827V288H74.667V64h362.667v74.667h-147.84 C265.117,138.696,245.363,158.45,245.333,182.827z M480,467.84c-0.012,12.602-10.225,22.815-22.827,22.827h-167.68 c-12.602-0.012-22.815-10.225-22.827-22.827V448H480V467.84z M480,426.667H266.667V213.333H480V426.667z M480,192H266.667v-9.173 c0.012-12.602,10.225-22.815,22.827-22.827h167.68c12.602,0.012,22.815,10.225,22.827,22.827V192z M480,145.216 c-6.44-3.939-13.789-6.144-21.333-6.4c0,0,0-0.096,0-0.149V53.333c0-5.891-4.776-10.667-10.667-10.667H64 c-5.891,0-10.667,4.776-10.667,10.667v245.333c0,5.891,4.776,10.667,10.667,10.667h181.333V329.6 c-11.688,2.745-18.937,14.446-16.192,26.134c1.887,8.033,8.159,14.305,16.192,16.192v22.741h-201.6 c-5.333,0-11.733-8.672-11.733-16V32.971c0.018-6.445,5.256-11.655,11.701-11.637c0.011,0,0.021,0,0.032,0h424.533 c6.445-0.035,11.698,5.16,11.733,11.605c0,0.011,0,0.021,0,0.032V145.216z",
    style: {
      fill: "rgb(140, 140, 140)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.989019, 0, 0, 0.961695, -0.936528, 2.798963)",
    style: {}
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.3dd73899e09e565b557af80d4ac4ad92.svg";
export { ForwardRef as ReactComponent };